import { useSearchParams } from 'next/navigation';

import { useSearchStore } from 'stores/searchStore';

export const useGetSearchTerm = () => {
  const searchParams = useSearchParams();

  const term = searchParams?.get('term') || '';

  return { term };
};

export const useToggleSearch = () => {
  const isActive = useSearchStore(state => state.isActive);
  const setActive = useSearchStore(state => state.setActive);
  const setInactive = useSearchStore(state => state.setInactive);

  return { isActive, setActive, setInactive };
};
